<template>
  <div class="section-heading" >
    <template v-if="headingType === 'top'">
      <div role="heading" aria-level="3">{{ section }}</div>
    </template>
    <template v-else-if="headingType === 'bottom'">
     <template v-for="(sectionButton, j) in sectionButtons">
       <div :key="`${j}-sectionButton`">{{j}}
      <section-heading-button   v-if="sectionButton && sectionButton.status !== 'Disabled'" :section="section" :sectionButton="sectionButton"></section-heading-button>
     </div>
      </template>
    </template>
    <template v-else>
      <div role="heading" aria-level="3">{{ section }}</div>
      <div style="display: flex;padding-right: 10px;">
        <template v-for="(sectionButton, j) in sectionButtons">
       <div :key="`${j}-sectionButton`" >
        <section-heading-button v-if="sectionButton && sectionButton.status !== 'Invisible'" :section="section" :sectionButton="sectionButton"></section-heading-button>
           </div>
      </template>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import SectionHeadingButton from './widgets/SectionHeadingButton';

export default {
  props: ['section', 'headingType'],
  components: {
    SectionHeadingButton,
  },
  computed: {
    /**
     * Search through `pageData.add_buttons` for the item with its `section` matching
     * this `section` string's value. That button, if any, belongs on this section heading.
     */
    sectionButtons() {
      let tempArr=[];
      const pageData = this.$store.state.updatePageData.pageData;
      const buttons = pageData.section_buttons || [];
      const sectionButtons = buttons.filter(button => button.section === this.section);
     //SetAsPrimaryApplicant for occupant page should be always first button,so swaping position to index 0
      for(var index=0; index<sectionButtons.length; index++)
      {if(index==1){
        if(sectionButtons[1].name==='SetAsPrimaryApplicant')
         { tempArr=sectionButtons[0];
         sectionButtons[0]=sectionButtons[1];
         sectionButtons[1]=tempArr;
         }
        }
      }
      return sectionButtons;
    },
  },
};
</script>

<style scoped>
.section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/SectionHeading.vue?3068db1a